import { render, staticRenderFns } from "./BadgeCellRenderer.vue?vue&type=template&id=1aa496f4"
import script from "./BadgeCellRenderer.vue?vue&type=script&lang=js"
export * from "./BadgeCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports